export const comments_3389323 = {"data":{"data":[],"links":{}}}